import { createFeatureSelector } from '@ngrx/store'
import { MB_SITE_CONTEXT_FEATURE, MbSiteContextState } from '../state'

export const getMbSiteContextState = createFeatureSelector<MbSiteContextState>(MB_SITE_CONTEXT_FEATURE)
